import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SloanInvoiceAccountSummaryModule } from './sloan-invoice-account-summary/sloan-invoice-account-summary.module';
import { SloanInvoiceListSearchResultModule } from './sloan-invoice-list-search-result/sloan-invoice-list-search-result.module';

@NgModule({
  imports: [CommonModule, SloanInvoiceAccountSummaryModule, SloanInvoiceListSearchResultModule],
})
export class SloanInvoiceModule {}
